/**
 * Although refactored heavily, this still feels like overkill for laying out some avatars
 * @param domId : where to render to
 *
 */
export function SocialMosaic(domId){

	// Static variables
	var avatarWidths = [45,46,47,48,49,50,51,52,53],
		minHeight    = 300;

	var $module = $('#'+domId),
		$placeholder = $('.xGridPlaceholder',$module),
		$avatarGridCell = $module.parents('.xCell');


	// Internal methods
	var requiredNumberOfNodes = function(){
			var dimensions = gridUnitDimension();
			// get the height based on the existing avatar nodes
			var rows = Math.floor(nodes().length / Math.floor(containerWidth() / dimensions));
			// height with available nodes i.e is padding of the collection required
			var numberOfRows = Math.ceil(Math.max(minHeight,dimensions*rows)/dimensions);
			return unitsPerRow()*numberOfRows;
		},
		containerWidth = function(){
			return $('.xGridPlaceholder',$module).innerWidth();
		},
		gridUnitDimension = function(){
			var gridUnitDimension,
				remainder = Math.max.apply(null, avatarWidths),
				width = containerWidth(),
				len = avatarWidths.length,
				i = 0;
			for (; i < len; i++) {
				var test = width % avatarWidths[i];
				if (test < remainder) {
					remainder = test;
					gridUnitDimension = avatarWidths[i];
				}
			}
			return gridUnitDimension;
		},
		unitsPerRow = function(){
			return Math.floor(containerWidth()/gridUnitDimension());
		},
		rows = function(){
			return Math.floor(requiredNumberOfNodes() / Math.floor(containerWidth() / gridUnitDimension()));
		},
		moduleHeight = function(){
			return rows() * gridUnitDimension();
		},
		nodes = function(){
			return $('.xItem', $placeholder);
		},
		randomiseArray = function( inputArr ){
			// randomise array using Fisher Yates http://sedition.com/perl/javascript-fy.html
			var i = inputArr.length, j, tempi, tempj;
			if ( i == 0 ) return false;
			while ( --i ) {
				j = Math.floor( Math.random() * ( i + 1 ) );
				tempi = inputArr[i];
				tempj = inputArr[j];
				inputArr[i] = tempj;
				inputArr[j] = tempi;
			}
			return inputArr;
		},
		processNodesToDisplay = function( $el ){
			var reqNodes = requiredNumberOfNodes(),
				arr = [];

			while (arr.length < reqNodes) {
				var newArr = nodes().clone().get().slice(0);
				// copy the original nodes array to pad out to the required number of nodes
				arr = arr.concat(newArr);
			}
			while (arr.length > reqNodes) {
				var domObj = arr.pop(); // remove item from array
			}

			$el.find('.xContainerInner').append( $( randomiseArray(arr) ) );
		};

// Public methods



	this.init = function(){

		$avatarGridCell.css({
			opacity:0,
			backgroundColor:'transparent'
		});

		$placeholder.css({
			height:0,
			overflow:'hidden'
		});

		var $grid = $('.xGridTarget',$module),
			dimensionPx = gridUnitDimension();

		processNodesToDisplay($grid);

		$('.xMediaAvatar',$module).css({
			width :dimensionPx,
			height:dimensionPx
		});

		$grid.css('visibility','visible');
		$avatarGridCell.animate({opacity:1},1000);

		this.tooltips = new MosaicTip(domId);
		this.tooltips.addTooltips();

	};

	this.reset = function(){
		$module.find('.xGridTarget .xContainerInner').html('');
		this.init();
	};

	this.containerWidth = containerWidth;
	this.gridUnitDimension = gridUnitDimension;


	// check if the components have completed (re-)layout
	var publishLayoutCompleteEvent = function(msg) {
		var message = ("undefined" === typeof msg? "windowLayoutComplete" : msg),
			timeout = null,
			checkLayoutComplete = function() {
				timeout = setTimeout(layoutComplete, 500);
			},
			layoutComplete = function() {
				clearTimeout(timeout);
				$.event.trigger({ type: "windowLayoutComplete", message: message });
			};
		checkLayoutComplete();
	};

	// add smart resize & publish event on window resize
	$.fn.smartresize = function(fn){
		return fn ? this.bind('resize', _.debounce(fn, 250)) : this.trigger('smartresize');
	};

	$(window).smartresize(function() {
		publishLayoutCompleteEvent();
	});

	// publish event on document ready (first load)

	$(window).ready(function() {
		publishLayoutCompleteEvent("documentReady");
	});

}


/**
 * Add tool tips to the avatars with tweet content etc
 * @param domId
 * @constructor
 */

export function MosaicTip(domId){

	var _id = domId,
		_ttip, _timer,
		autoTriggerFlag = "autoTriggerFlag";

	var mosaic = function(){
			return $('.xGridTarget .xContainerInner','#'+_id);
		},
		wrapper = function(){
			return mosaic().closest('.xCellInner')
		},
		avatars = function(){
			return mosaic().find('img.xMediaAvatar')
		},
		avatarFirst = function(){
			var list = mosaic()[0].getElementsByTagName('IMG'),
				len  = list.length,
				i    = 0;
			for(;i<len;i++){
				if($(list[i]).hasClass('xMediaAvatar')) return $(list[i]);
			}
			return avatars().first();
		},
		visibleAvatarLength = function(actualLen){
			var $wrap  = wrapper(),
				$first = avatarFirst();

			return Math.min( Math.floor( ($wrap.height() / $first.height()) / $first.height() ) * ($wrap.width() / $first.width()), actualLen );
		};

	var showTooltip = function(e){
		var updateTooltip = function(el){
				if('function'===typeof el.getAttribute && _ttip.qtip('api')){
					if(el.getAttribute('data-ngxsourcename')){
						_ttip.trigger('show');
						_ttip.qtip('api').set({
							'position.target' : el,
							'style.classes'   : 'qtip-bootstrap '+el.getAttribute('data-ngxnetwork'),
							'content.title'   : el.getAttribute('data-ngxsourcename')||'',
							'content.text'    : el.getAttribute('data-ngxtitle')||''
						});

					}
				}
			},
			getRandomAvatar = function(){
				var _avID = Math.floor( Math.random() * visibleAvatarLength( avatars().length) );
				return avatars().eq( _avID );
			};

		if('undefined'!==typeof e && e.currentTarget){
			updateTooltip(e.currentTarget);
			return true;
		} else if(mosaic().data(autoTriggerFlag)===true){
			updateTooltip( getRandomAvatar() );
			triggerTimer();
			return true;
		}
		return false;
	};

	var resetTimer = function(){
			clearTimeout(_timer);
		},
		triggerTimer = function(){
			resetTimer();
			_timer = setTimeout( showTooltip, 7500);
		},
		preventAuto = function(){
			resetTimer();
			mosaic().data(autoTriggerFlag,false);
		},
		initialiseTimer = function(){
			//_ttip.trigger('hide');
			mosaic().data(autoTriggerFlag,true);
			triggerTimer();
		};

	var addTooltips = function(){
		var $initial;
		if( 'undefined' === typeof _ttip ){
			$initial = avatarFirst();
			_ttip = mosaic().qtip({
				content: {
					title : '',
					text  : ''
				},
				position: {
					target : $initial,
					effect : false,
					my     : 'top center',
					at     : 'bottom center',
					viewport: mosaic()
				},
				show : {
					ready: true,
					delay: 0,
					event: 'show'
				},
				hide : {
					event: 'hide'
				},
				style: {
					classes: 'qtip-bootstrap '+$initial.attr('data-ngxnetwork')
				}
			});
		} else {
			showTooltip();
		}

		wrapper()
			.on('mouseenter',preventAuto)
			.on('mouseleave',initialiseTimer);
		avatars()
			.on('mouseenter',showTooltip);
	};

	this.init = initialiseTimer;
	this.addTooltips = addTooltips;

};
